import React, { useEffect, useState } from 'react';
import Navigation from '../components/common/Navigation';
import Footer from '../components/common/Footer';
import Globe from '../components/home/Globe';
import { env } from '../config/env';

const PressRelease = () => {
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [isMobile, setIsMobile] = useState(false);
    const documentsPerPage = 10;

    // Nouveau useEffect pour forcer le scroll en haut au chargement du composant
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Hook pour détecter les changements de taille d'écran
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const fetchDocuments = async () => {
            try {
                const response = await fetch(`${env.API_URL}/information-investisseur`);
                console.log(env.API_URL);
                if (!response.ok) {
                    throw new Error('Erreur lors du chargement des documents');
                }
                const data = await response.json();
                setDocuments(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchDocuments();
    }, []);

    const formatDate = (timestamp) => {
        return new Date(timestamp * 1000).toLocaleDateString('fr-FR');
    };

    const handleTitleClick = (fileName) => {
        const pdfUrl = `https://www.acheter-louer.fr/api/investisseur/pdf/${fileName}`;
        window.open(pdfUrl, '_blank');
    };

    const indexOfLastDocument = currentPage * documentsPerPage;
    const indexOfFirstDocument = indexOfLastDocument - documentsPerPage;
    const currentDocuments = documents.slice(indexOfFirstDocument, indexOfLastDocument);
    const totalPages = Math.ceil(documents.length / documentsPerPage);

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const goToPage = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            <Navigation />
            <main
                className="main-wrapper"
                style={{
                    minHeight: '100vh',
                    paddingBottom: isMobile ? '50rem' : '75rem',
                }}
            >
                <div className="section_hero-others">
                    <div className="padding-global">
                        <div className="container-large">
                            <div className="hero-404_wrapper">
                                <div className="spacer-2"></div>
                                <div className="align-center">
                                    <div className="max-width-80">
                                        <div className="text-align-center">
                                            <h1 className="heading-style-h1">Investor Information</h1>
                                            <div className="spacer-1"></div>
                                            <div className="text-size-large text-color-grey-50">
                                                Access official documents and information for Sol Treasury Corp investors.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="spacer-4"></div>

                                {/* Section des documents */}
                                <div className="max-width-80 align-center">
                                    {loading && (
                                        <div style={{ textAlign: 'center', padding: '2rem' }}>
                                            <div className="text-size-large text-color-grey-50">Loading documents...</div>
                                        </div>
                                    )}

                                    {error && (
                                        <div
                                            style={{
                                                textAlign: 'center',
                                                padding: '2rem',
                                                color: '#ff6b6b',
                                            }}
                                        >
                                            Error : {error}
                                        </div>
                                    )}

                                    {!loading && !error && documents.length === 0 && (
                                        <div style={{ textAlign: 'center', padding: '2rem' }}>
                                            <div className="text-size-large text-color-grey-50">No document available for the moment.</div>
                                        </div>
                                    )}

                                    {!loading && !error && documents.length > 0 && (
                                        <div
                                            style={{
                                                width: '100%',
                                                maxWidth: '800px',
                                                margin: '0 auto',
                                            }}
                                        >
                                            {/* Liste des documents */}
                                            {currentDocuments.map((doc, index) => (
                                                <div
                                                    key={doc._id}
                                                    style={{
                                                        borderBottom:
                                                            index < currentDocuments.length - 1 ? '1px solid rgba(255, 255, 255, 0.1)' : 'none',
                                                        padding: '1.5rem 0',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => handleTitleClick(doc.file)}
                                                >
                                                    <div
                                                        style={{
                                                            color: '#FAFAFA',
                                                            fontSize: isMobile ? '1rem' : '1.1rem',
                                                            lineHeight: '1.4',
                                                            marginBottom: '0.5rem',
                                                            textDecoration: 'none',
                                                            ...(isMobile && {
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                maxWidth: '250px',
                                                            }),
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.textDecoration = 'underline';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.textDecoration = 'none';
                                                        }}
                                                    >
                                                        {doc.title}
                                                    </div>

                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            marginTop: '0.5rem',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                color: '#888',
                                                                fontSize: '0.9rem',
                                                            }}
                                                        >
                                                            {formatDate(doc.display_at)}
                                                        </div>
                                                        <div
                                                            style={{
                                                                color: '#888',
                                                                fontSize: '0.9rem',
                                                            }}
                                                        >
                                                            →
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                            {/* Pagination en bas */}
                                            {totalPages > 1 && (
                                                <>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            marginTop: '3rem',
                                                            gap: isMobile ? '0.5rem' : '1rem',
                                                            flexWrap: 'wrap',
                                                        }}
                                                    >
                                                        {/* Bouton Précédent */}
                                                        <button
                                                            onClick={prevPage}
                                                            disabled={currentPage === 1}
                                                            style={{
                                                                background:
                                                                    currentPage === 1
                                                                        ? 'rgba(255, 255, 255, 0.1)'
                                                                        : 'rgba(255, 255, 255, 0.2)',
                                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                                borderRadius: '8px',
                                                                padding: isMobile ? '0.5rem 1rem' : '0.75rem 1.5rem',
                                                                color: currentPage === 1 ? '#666' : '#FAFAFA',
                                                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                                                fontSize: isMobile ? '0.8rem' : '0.9rem',
                                                                transition: 'all 0.3s ease',
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                if (currentPage !== 1) {
                                                                    e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                                                                }
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if (currentPage !== 1) {
                                                                    e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                                                                }
                                                            }}
                                                        >
                                                            ← Previous
                                                        </button>

                                                        {/* Numéros de pages */}
                                                        <div style={{ display: 'flex', gap: '0.3rem', flexWrap: 'wrap' }}>
                                                            {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
                                                                <button
                                                                    key={pageNumber}
                                                                    onClick={() => goToPage(pageNumber)}
                                                                    style={{
                                                                        background: currentPage === pageNumber ? '#9945ff' : 'rgba(255, 255, 255, 0.1)',
                                                                        border: '1px solid rgba(255, 255, 255, 0.3)',
                                                                        borderRadius: '8px',
                                                                        padding: isMobile ? '0.5rem 0.75rem' : '0.75rem 1rem',
                                                                        color: '#FAFAFA',
                                                                        cursor: 'pointer',
                                                                        fontSize: isMobile ? '0.8rem' : '0.9rem',
                                                                        minWidth: isMobile ? '35px' : '45px',
                                                                        transition: 'all 0.3s ease',
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        if (currentPage !== pageNumber) {
                                                                            e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                                                                        }
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        if (currentPage !== pageNumber) {
                                                                            e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                                                                        }
                                                                    }}
                                                                >
                                                                    {pageNumber}
                                                                </button>
                                                            ))}
                                                        </div>

                                                        {/* Bouton Suivant */}
                                                        <button
                                                            onClick={nextPage}
                                                            disabled={currentPage === totalPages}
                                                            style={{
                                                                background:
                                                                    currentPage === totalPages
                                                                        ? 'rgba(255, 255, 255, 0.1)'
                                                                        : 'rgba(255, 255, 255, 0.2)',
                                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                                borderRadius: '8px',
                                                                padding: isMobile ? '0.5rem 1rem' : '0.75rem 1.5rem',
                                                                color: currentPage === totalPages ? '#666' : '#FAFAFA',
                                                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                                                fontSize: isMobile ? '0.8rem' : '0.9rem',
                                                                transition: 'all 0.3s ease',
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                if (currentPage !== totalPages) {
                                                                    e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                                                                }
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if (currentPage !== totalPages) {
                                                                    e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                                                                }
                                                            }}
                                                        >
                                                            Next →
                                                        </button>
                                                    </div>

                                                    {/* Info pagination */}
                                                    <div
                                                        style={{
                                                            textAlign: 'center',
                                                            marginTop: '1rem',
                                                            color: '#888',
                                                            fontSize: isMobile ? '0.8rem' : '0.9rem',
                                                        }}
                                                    >
                                                        Page {currentPage} of {totalPages} ({documents.length} documents)
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
            <Globe />
        </>
    );
};

export default PressRelease;
